<template>
  <div class="main_wrap">
    <h3>我的文件</h3>
    <header>
      <div class="tool-bar">
        <template v-if="checkArr.length > 0">
          <el-button class="primary-plain" @click="downloadFiles"
            >下载 ({{ checkArr.length }})
          </el-button>
        </template>
        <el-button class="primary" @click="showFoldDialog('create')"
          >新建文件夹</el-button
        >
        <el-input
          class="input"
          placeholder="请输入章节名称"
          clearable
          v-model="keywordInput"
          @keyup.enter.native="search"
          @clear="search"
          @input="ifEmpty"
        >
          <i
            slot="prefix"
            class="el-input__icon el-icon-search"
            @click="search"
          />
        </el-input>
        <el-select
          class="input"
          v-model="grade"
          clearable
          placeholder="全部年级"
          @change="search"
        >
          <el-option-group
            v-for="group in gradeList"
            :key="group.id"
            :label="group.name"
          >
            <el-option
              v-for="item in group.children"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-option-group>
        </el-select>
      </div>
    </header>
    <main>
      <el-checkbox-group v-model="checkArr">
        <!-- 文件夹 层级 -->
        <el-collapse class="fold-collapse" v-model="openedFolds">
          <el-collapse-item
            v-for="fold in fileList"
            :key="fold.folderId"
            :name="fold.folderId"
          >
            <!-- 文件夹的标题 -->
            <div class="fold-header" slot="title">
              <div class="fold-title">
                <div class="fold-icon">
                  <img src="@/assets/icons/icon_fold.png" />
                </div>
                <div class="fold-name">{{ fold.folderName }}</div>
                <div class="fold-tip" v-if="fold.defaultFolderTag">默认</div>
                <div class="fold-filenum">
                  已生成{{ fold.errorTextbookList.length }}份班级学情分析报告
                </div>
              </div>
              <div class="fold-tool" v-if="!fold.defaultFolderTag">
                <el-popover
                  popper-class="fold-popper"
                  trigger="hover"
                  placement="bottom"
                >
                  <div @click="handleRename(fold)">重命名</div>
                  <div @click="deleteFold(fold)">删除</div>
                  <i class="el-icon-more" slot="reference"></i>
                </el-popover>
              </div>
            </div>
            <!-- 文件夹的内容 -->
            <el-card class="card">
              <template slot="header">
                <div class="card-header-txt">
                  <div
                    v-for="i in getSubject(fold.errorTextbookList)"
                    :key="i.subjectId"
                    :class="{ current: i.subjectId == fold.subjectValue }"
                    @click="changeSubject(fold, i)"
                  >
                    <p>{{ i.subjectName }}</p>
                    <p v-if="i.subjectId == '-1'" class="sub-number">
                      <sub>
                        共
                        <span>{{
                          formatChapterList(fold.errorTextbookList).length
                        }}</span>
                        个章节
                      </sub>
                    </p>
                  </div>
                </div>
              </template>
              <!-- 文件 层级 -->
              <template
                v-if="fold.errorTextbookList.length == 0"
              >
                <Empty
                  text="该文件夹下已无学情报告，快去创建吧~"
                  height="100%"
                />
              </template>
              <template v-else>
                <el-collapse accordion class="file-collapse">
                  <div
                    v-for="(file, index) in formatChapterList(
                      fold.errorTextbookList
                    )"
                    :key="index"
                  >
                    <el-collapse-item
                      :name="file.id"
                      v-if="
                        fold.subjectValue == '-1' ||
                        fold.subjectValue == file.subjectId
                      "
                    >
                      <template slot="title">
                        <div class="file-title">
                          <el-checkbox
                            :label="
                              file.parentChapterId + file.children[0].folderId
                            "
                            :key="file.parentChapterId"
                            class="checkbox"
                          >
                            {{ file.parentChapterName }}
                          </el-checkbox>
                        </div>
                      </template>
                      <div class="collapse-panel-body">
                        <el-row
                          :gutter="20"
                          class="collapse-panel-body-item"
                          :key="i.id"
                          v-for="i in file.children"
                        >
                          <el-col :span="15">{{ i.chapterName }}</el-col>
                          <el-col :span="4" class="collapse-panel-item-time">{{
                            i.errorTextbookCreateTime
                          }}</el-col>
                          <el-col :span="4" class="collapse-panel-item-buttons">
                            <el-button type="text" @click="deleteReport(i)"
                              >删除</el-button
                            >
                            <el-button type="text" @click="goToUpdate(i)"
                              >修改</el-button
                            >
                            <el-button
                              type="text"
                              @click="openUrl(i.errorTextbookUrl)"
                              >查看</el-button
                            >
                          </el-col>
                        </el-row>
                      </div>
                    </el-collapse-item>
                  </div>
                </el-collapse>
              </template>
            </el-card>
          </el-collapse-item>
          <template v-if="fileList.length == 0">
            <el-empty
              :image="require('@/assets/images/collectionEmpty.png')"
              description="暂无符合搜索条件的学情报告"
            ></el-empty>
          </template>
        </el-collapse>
      </el-checkbox-group>
    </main>
    <el-dialog
      class="dialog"
      :visible.sync="foldDialogShow"
      :close-on-click-modal="false"
      @close="closeFoldDialog"
      width="42rem"
    >
      <template v-if="foldDialogType == 'create'">
        <div class="title" slot="title">新建文件夹</div>
        <div class="tip">请输入文件夹名称</div>
        <el-input
          class="input"
          clearable
          v-model="newFoldKeyword"
          @input="
            (v) => {
              newFoldKeyword = v.replace(/[^\w\u4E00-\u9FA5]/g, '');
              newFoldKeyword = newFoldKeyword.replace(/[a-zA-Z]/g, '');
            }
          "
          :maxlength="10"
        ></el-input>
        <div class="btn-tool">
          <el-button class="cancel" type="info" @click="foldDialogShow = false">
            取消
          </el-button>
          <el-button class="confirm" type="primary" @click="createNewFold"
            >确定</el-button
          >
        </div>
      </template>
      <template v-if="foldDialogType == 'rename'">
        <div class="title" slot="title">重命名文件夹</div>
        <div class="tip">请输入文件夹名称</div>
        <el-input
          class="input"
          clearable
          v-model="renameFoldKeyword"
          @input="
            (v) => {
              renameFoldKeyword = v.replace(/[^\w\u4E00-\u9FA5]/g, '');
              renameFoldKeyword = renameFoldKeyword.replace(/[a-zA-Z]/g, '');
            }
          "
          :maxlength="10"
        ></el-input>
        <div class="btn-tool">
          <el-button class="cancel" type="info" @click="foldDialogShow = false">
            取消
          </el-button>
          <el-button class="confirm" type="primary" @click="renameFold"
            >确定</el-button
          >
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserDocuments,
  createNewFold,
  renameFold,
  deleteFold,
  downloadFiles,
  deleteFile,
} from "@/api/mine";
import { schoolSection } from "@/utils/common";
import Empty from "@/components/empty.vue";

export default {
  name: "myDocument",
  components: {
    Empty,
  },
  data: function () {
    return {
      //未处理的文件数据
      fileList: [],
      openedFolds: [],
      //搜索框
      keywordInput: "",
      //年级select框
      grade: "",
      gradeList: [],

      //勾选的要下载的文件
      checkArr: [],
      //新建文件夹弹窗
      foldDialogShow: false,
      foldDialogType: "",
      newFoldKeyword: "",
      renameFoldKeyword: "",
      //被选中要重命名的文件
      chosenFold: {},
    };
  },
  computed: {},
  methods: {
    //加载数据
    async loadData() {
      this.gradeList = schoolSection;
      var data = await getUserDocuments(this.keywordInput, this.grade);
      data.map((item) => {
        item.subjectValue = -1;
      });
      this.fileList = data;
    },
    //打开文件夹弹窗
    showFoldDialog(type) {
      this.foldDialogType = type;
      this.foldDialogShow = true;
    },
    //打开重命名弹窗
    handleRename(fold) {
      this.chosenFold = fold;
      this.showFoldDialog("rename");
    },
    //关闭文件夹弹窗
    closeFoldDialog() {
      this.foldDialogShow = false;
      this.newFoldKeyword = "";
      this.renameFoldKeyword = "";
    },
    //新建文件夹
    createNewFold() {
      if (this.newFoldKeyword.length) {
        createNewFold(this.newFoldKeyword).then(() => {
          this.$message({
            message: "创建成功",
            type: "success",
          });
          this.loadData();
          this.foldDialogShow = false;
        });
      } else {
        this.$message({
          message: "文件夹名称为空",
          type: "error",
          offset: 120,
          customClass: "errorTips",
        });
      }
    },
    //重命名文件夹
    renameFold() {
      if (this.renameFoldKeyword.length) {
        renameFold(this.renameFoldKeyword, this.chosenFold.folderId).then(
          () => {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.loadData();
            this.foldDialogShow = false;
          }
        );
      } else {
        this.$message({
          message: "文件夹名称为空",
          type: "error",
          offset: 120,
          customClass: "errorTips",
        });
      }
    },
    //删除文件夹
    deleteFold(fold) {
      this.$confirm(
        `删除“${fold.folderName}”后，会将文件夹内所有报告都删除，且删除后不可恢复，是否删除`,
        "提示",
        {
          // distinguishCancelAndClose: true,
          confirmButtonText: "确认删除",
          cancelButtonText: "取消",
          // center: true,
        }
      )
        .then(() => {
          //确认删除
          deleteFold(fold.folderId).then(() => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.search();
          });
        })
        .catch((action) => {
          //取消
        });
    },
    //搜索文件
    async search() {
      await this.loadData();
      if (this.keywordInput || this.grade) {
        this.fileList = this.fileList.filter((item) => {
          return item.errorTextbookList.length > 0;
        });
      }
    },
    //判断输入框是否为空
    ifEmpty(value) {
      if (!value) {
        this.search();
      }
    },
    //返回科目
    getSubject(arr) {
      let subjectList = [{ subjectName: "全部科目", subjectId: "-1" }];
      arr.map((item) => {
        if (
          subjectList.find((secItem) => {
            return secItem.subjectId == item.subjectId;
          }) == undefined
        ) {
          const tem = {
            subjectName: item.subjectName,
            subjectId: item.subjectId,
          };
          subjectList.push(tem);
        }
      });
      subjectList.sort((a, b) => {
        return parseInt(a.subjectId) - parseInt(b.subjectId);
      });
      return subjectList;
    },
    //格式化章节
    formatChapterList(arr) {
      const result = [];
      arr.map((chapterItem) => {
        // 按单元把数据分组
        const listItem = result.find((item) => {
          return item.parentChapterId == chapterItem.parentChapterId;
        });
        if (listItem) {
          listItem.children.push(chapterItem);
        } else {
          result.push({
            subjectId: chapterItem.subjectId,
            subjectName: chapterItem.subjectName,
            parentChapterId: chapterItem.parentChapterId,
            parentChapterName: chapterItem.parentChapterName,
            children: [chapterItem],
          });
        }
      });
      return result;
    },
    //选择科目
    changeSubject(fold, chapter) {
      fold.subjectValue = chapter.subjectId;
    },
    //下载文件
    async downloadFiles() {
      let arr = [];
      this.checkArr.map((item) => {
        this.fileList.map((fold) => {
          fold.errorTextbookList.map((file) => {
            if (item == file.parentChapterId + file.folderId) {
              arr.push(file.id);
            }
          });
        });
      });
      if (arr.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
        });
        try {
          await downloadFiles(arr.join(","));
          this.$message({
            message: "下载成功",
            type: "success",
          });
        } catch (e) {
          this.$message({
            message: "下载失败",
            type: "error",
          });
        } finally {
          loading.close();
        }
      } else {
        this.$message({
          message: "请选择文件再下载",
          type: "error",
        });
      }
    },
    //删除文件
    deleteReport(item) {
      this.$confirm(`确定要删除"${item.chapterName}"的学情报告吗`, {
        // distinguishCancelAndClose: true,
        confirmButtonText: "确认删除",
        cancelButtonText: "取消",
        center: true,
      })
        .then(() => {
          deleteFile(item.chapterId, item.errorTextbookId, item.folderId).then(
            () => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              // 以下是为了清空勾选内容
              const findItem = this.fileList.find((fold) => {
                return fold.folderId == item.folderId;
              });
              const filterArr = findItem.errorTextbookList.filter((errItem) => {
                return errItem.parentChapterId == item.parentChapterId;
              });
              if (filterArr.length == 1) {
                const checkedId =
                  filterArr[0].parentChapterId + filterArr[0].folderId;
                const findIndex = this.checkArr.indexOf(checkedId);
                this.checkArr.splice(findIndex, 1);
              }
              //重新加载数据
              this.loadData();
            }
          );
        })
        .catch(() => {});
    },
    //跳转至修改学情报告
    goToUpdate(item) {
      const courseId = item.courseId;
      const chapterId = item.chapterId;
      const grade = item.errorTextbookGrade;
      const questionIds = item.questionIds.join(",");
      const folderId = item.folderId;
      console.log(item);
      this.$router.push(
        `/course/classStudyCondition?courseId=${courseId}&chapterId=${chapterId}&grade=${grade}&questionIds=${questionIds}&classId=${folderId}`
      );
    },
    //查看学情报告
    openUrl(url) {
      window.open(url, "_blank");
    },
  },
  async mounted() {
    await this.loadData();
    //进页面展开默认文件夹
    this.openedFolds.push(this.fileList[0].folderId);
  },
};
</script>
<style lang="scss" scoped>
//禁用置灰
// .disabled {
//   opacity: 0.5;
// }

.main_wrap {
  width: 100%;
  height: 100%;
  position: relative;

  h3 {
    position: absolute;
    z-index: 99;
    font-size: 2rem;
  }

  header {
    position: relative;
    width: 100%;
    overflow: hidden;
    .tool-bar {
      float: right;
      display: flex;
      ::v-deep .el-button {
        font-size: 1.6rem;
        margin: 2rem 1rem;
        height: 4rem;
        border-radius: 0.4rem;
        padding: 1.2rem 2rem;
        border: none;
      }

      .primary-plain {
        background: #e5f6fd;
        color: #09a7ff;
      }

      .primary {
        background: $color-primary;
        color: #ffffff;
      }

      .input {
        margin: 2rem 1rem;
      }

      ::v-deep .el-input__inner {
        width: 20rem;
        font-size: 1.4rem;
        line-height: 4rem;
        height: 4rem;
        border-radius: 0.4rem;
        padding: 0 3rem;
        border: none;
      }

      ::v-deep .el-input__prefix {
        .el-icon-search {
          height: 4rem;
          line-height: 4rem;
          color: #999999 !important;
          font-size: 1.6rem;
        }
      }

      ::v-deep .el-input__suffix .el-input__suffix-inner .el-input__clear {
        font-size: 1.4rem;
        width: 2.5rem;
        line-height: 4rem;
      }

      ::v-deep .el-input__suffix .el-input__suffix-inner .el-select__caret {
        height: 4rem;
        line-height: 4rem;
        font-size: 1.6rem;
        color: #333333 !important;
        font-weight: bold;
      }
    }
  }

  main {
    width: 100%;
    margin-top: 1rem;

    ::v-deep .el-collapse {
      border: none;
      .el-collapse-item {
        background: #ffffff;
        margin-bottom: 2rem;
        padding: 0 3rem;

        .el-collapse-item__header {
          height: 4.8rem;
          line-height: normal;
          border-bottom: 0.1rem #f4f5f8 solid;
          padding: 1rem 0 0.5rem;
        }
        .el-collapse-item__content {
          padding-bottom: 2.5rem;
        }
      }
    }

    ::v-deep .fold-header {
      flex: 1 0 90%;
      order: 1;
      .el-collapse-item__header {
        flex: 1 0 auto;
        order: -1;
      }
    }

    ::v-deep .el-collapse-item__arrow {
      font-size: 1.3rem;
      font-weight: 700;
    }

    //文件夹折叠 样式
    .fold-collapse {
      .fold-header {
        display: flex;
        justify-content: space-between;
        .fold-title {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          .fold-icon {
            img {
              width: 3rem;
              height: 2.7rem;
            }
            margin: 0 1.5rem;
          }
          .fold-name {
            font-size: 1.8rem;
            line-height: 4.8rem;
            font-weight: 700;
            color: #333333;
            margin-right: 1rem;
          }
          .fold-tip {
            font-size: 1.6rem;
            color: $color-primary;
            padding: 0 0.6rem 0.1rem;
            box-sizing: border-box;
            border: $color-primary 0.1rem solid;
            border-radius: 0.4rem;
            margin-right: 1.2rem;
          }
          .fold-filenum {
            color: #666666;
            font-size: 1.4rem;
          }
        }
        .fold-tool {
          margin-right: 2rem;
          line-height: 4.8rem;
          i {
            cursor: pointer;
            font-size: 2rem;
            color: #7d7d7d;
          }
        }
      }

      ::v-deep .card {
        border: none;
        box-shadow: none;

        .el-card__header {
          border: none;
          padding: 1.8rem 2rem 1rem;
        }
        .el-card__body {
          padding: 2rem 0 4rem;
        }

        //科目选择 样式
        .card-header-txt {
          display: flex;

          div {
            font-size: 1.8rem;
            color: #000000;
            margin-right: 5rem;
            text-align: left;
            cursor: pointer;

            p {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }

            .sub-number {
              text-align: center;
              font-size: 1.4rem;
            }

            sub {
              font-size: 1.4rem;
              color: #666666;
              font-weight: normal;
              span {
                font-size: 1.6rem;
                font-weight: 700;
              }
            }
          }

          div.current {
            color: $color-primary;
            font-weight: bold;
          }
        }

        //文件折叠 样式
        .file-collapse {
          .el-collapse-item__wrap {
            border-bottom: none;
          }
          .el-collapse-item {
            padding: 0;
            margin-bottom: 0;
            .el-collapse-item__header {
              background-color: #f4f5f8;
              padding: 0.5rem 2rem;
            }
            .el-collapse-item__content {
              padding-bottom: 0;
            }
          }

          //修改复选框样式
          .el-checkbox {
            display: flex;
            align-items: center;
            .el-checkbox__input {
              font-size: 1.3rem;
              .el-checkbox__inner {
                width: 1.8rem;
                height: 1.8rem;

                &::after {
                  left: 0.4rem;
                  top: 0rem;
                  width: 0.6rem;
                  height: 1rem;
                  border-width: 0.2rem;
                }
                &:hover {
                  border-color: $color-primary;
                }
              }
            }
            .el-checkbox__input.is-checked .el-checkbox__inner,
            .el-checkbox__input.is-indeterminate .el-checkbox__inner {
              background-color: $color-primary;
              border-color: $color-primary;
            }
            .el-checkbox__label {
              font-size: 1.8rem;
              font-weight: bold;
              color: #333;
            }
          }
          // 折叠面板内容区域
          .collapse-panel-body {
            box-sizing: border-box;
            padding: 0 0;
            overflow: hidden;
            background: rgba(234, 246, 255, 0);
            box-shadow: 0px 1px 0px 0px rgba(220, 220, 220, 0.78);
            border-bottom: 0.1rem solid #e5e5e5;

            .collapse-panel-body-item {
              padding: 0 4rem;
              font-size: 1.6rem;
              font-weight: 400;
              height: 6rem;
              line-height: 6rem;
              box-sizing: border-box;
              box-shadow: 0 0.1rem 0 0 rgba(220, 220, 220, 0.78);

              .collapse-panel-item-time {
                color: #666666;
              }

              .collapse-panel-item-buttons {
                text-align: right;

                .el-button {
                  margin-left: 3rem;
                  font-size: 1.6rem;
                  font-weight: 400;
                  color: #333333;
                }

                .el-button:hover {
                  color: $color-primary;
                }
              }
            }

            .collapse-panel-body-item:hover {
              background: rgba(47, 165, 255, 0.05);
            }
          }
        }
      }
    }
  }
  .dialog {
    ::v-deep .el-dialog {
      .el-dialog__header {
        padding: 2rem 2rem 0;
      }
      .el-dialog__body {
        padding: 0 2rem 2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .title {
        color: #000000;
        font-size: 1.8rem;
        font-weight: bold;
        margin-bottom: 3rem;
      }

      .tip {
        width: 100%;
        text-align: left;
        font-size: 1.6rem;
        color: #666666;
        margin-bottom: 2rem;
      }

      .input {
        margin-bottom: 3rem;
        .el-input__inner {
          width: 100%;
          height: 4.5rem;
          line-height: 4rem;
          font-size: 1.6rem;
        }
      }

      .el-input__clear {
        font-size: 1.4rem;
        width: 2.5rem;
        line-height: 4.5rem;
      }

      .btn-tool {
        display: flex;
        width: 100%;
        justify-content: flex-end;
        .cancel {
          background: #ffffff;
          color: #676767;
          border: 0.1rem solid #dcdfe6;
          height: 4rem;
          width: 8rem;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            font-size: 1.6rem;
          }
        }
        .confirm {
          background: $color-primary;
          height: 4rem;
          width: 8rem;
          margin-left: 2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            font-size: 1.6rem;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
//popover 样式
.fold-popper {
  min-width: 6rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem 2rem 0.5rem;
  border-radius: 1rem;
  div {
    font-size: 1.4rem;
    color: #000000;
    margin-bottom: 1rem;
    cursor: pointer;
    &:hover {
      color: $color-primary;
    }
  }
}
</style>